import axios from "axios";

const DEV_CUSTOMER_URL =
  "https://n4kl7g5v9i.execute-api.us-east-1.amazonaws.com/Prod/customers";
const PROD_CUSTOMER_URL =
  "https://customers.api.sagelyn.ai/customers";

const BASE_URL =
  process.env.REACT_APP_CUSTOMER_API_URL ||
  (process.env.REACT_APP_ENV === "development" ? DEV_CUSTOMER_URL : PROD_CUSTOMER_URL);

export interface UsageSummary {
  customer_id: string;
  period: string;
  posts: number;
  images: number;
  image_edits: number;
  video_seconds: number;
  credits_total: number;
  tokens: {
    input_tokens_total: number;
    output_tokens_total: number;
    total_tokens_total: number;
    perplexity_queries_total: number;
  };
  credit_balance: number;
  auto_refill_enabled: boolean;
  auto_refill_threshold: number;
  auto_refill_amount: number;
  /**
   * The Brand's own Seat cap. `null` means unlimited (Agency Pro) — SGL-398.
   * Never do arithmetic on it without checking `seats_unlimited` first:
   * `max_seats - seats_used` was NaN on an unlimited plan, and
   * `seats_used < max_seats` was false, which hid the invite form on the one
   * plan that has unlimited seats.
   */
  max_seats: number | null;
  seats_used: number;
  seats_unlimited: boolean;
  /** Agency-side operator Seats: Multi Brand has 3, Agency Pro unlimited, every other plan 0. */
  operator_seats_used: number;
  operator_seats_max: number | null;
  operator_seats_unlimited: boolean;
  /** The Brand Owner's plan key, e.g. "sagelyn multi brand"; null when unknown. */
  plan?: string | null;
  /** True when the server could not compute the seat numbers; show nothing rather than a wrong cap. */
  seats_error?: boolean;
  free_crawl_pages_remaining: number;
}

/** Can another Seat be added on this allowance? The client mirror of common.seats.capacity. */
export const hasSeatRoom = (
  used: number,
  max: number | null,
  unlimited: boolean
): boolean => unlimited || max === null || used < max;

/** Seats left, or null when unlimited. Never negative: a Brand over its cap reads 0 left, not -1. */
export const seatsRemaining = (
  used: number,
  max: number | null,
  unlimited: boolean
): number | null => (unlimited || max === null ? null : Math.max(0, max - used));

export const fetchUsageSummary = async (
  customerId: string,
  idToken: string
): Promise<UsageSummary> => {
  const response = await axios.get<UsageSummary>(`${BASE_URL}/${customerId}/usage`, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  return response.data;
};
